import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { getGlobalDateDisplayFormat } from '@miq/platform';
/*
 * L2-R6: moved from `src/app/shared/pipe/date-with-format.pipe.ts`. It could only move once
 * `getGlobalDateDisplayFormat` reached @miq/platform in this same pass. Like MomentTimezonePipe
 * (pipes/moment-timezone.pipe.ts) the format is resolved PER CALL, never frozen at module-eval.
 * The old host path is a re-export shim.
 */
@Pipe({
  name: 'dateWithFormat',
  standalone: true,
})
export class DateWithFormatPipe implements PipeTransform {
  public datePipe = inject(DatePipe);
  /**
   * @param value: string which is used as input to date pipe
   * @param args: accepts object with keys suffixFormat and otherThanCode
   * suffixFormat tells if the date has to be displayed with any hours mins ext.
   * otherThanCode will specify if we have to use value from key/value (default is code)
   */
  transform(
    value: string,
    args: { suffixFormat?: string; otherThanCode?: string } = { suffixFormat: '', otherThanCode: 'code' }
  ): string {
    const { suffixFormat, otherThanCode } = args;
    const withSuffixFormat = getGlobalDateDisplayFormat(otherThanCode) + suffixFormat;
    return this.datePipe.transform(value, withSuffixFormat);
  }
}
